window.storeLocations = [
  {
    id: "gid://shopify/Location/85775712470",
    name: "Alcabideche - CC CascaiShopping",
    address: {
      latitude: 38.73893109999999,
      longitude: -9.4038119,
      phone: "+351 211 388 633",
      province: "Lisboa",
      address1: "Lojas 1.046 - 1.047 Piso 1",
      address2: "",
      city: "Alcabideche",
      country: "Portugal",
      zip: "2645-543",
      countryCode: "PT",
      hours:
        '[["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/84216578262",
    name: "Almacén eCommerce",
    address: {
      latitude: 41.5311455,
      longitude: 2.1064791,
      phone: "",
      province: "Barcelona",
      address1: "Carrer de Joanot Martorell 96",
      address2: "Muelle 8",
      city: "Sabadell",
      country: "Spain",
      zip: "08203",
      countryCode: "ES",
      hours:
        '[["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85775581398",
    name: "Barcelona - La Roca Village",
    address: {
      latitude: 41.6112208,
      longitude: 2.3442788,
      phone: "+34 935 754 818",
      province: "Barcelona",
      address1: "La Roca Village s/n",
      address2: "",
      city: "Santa Agnès de Malanyanes",
      country: "Spain",
      zip: "08430",
      countryCode: "ES",
      hours:
        '[["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85775745238",
    name: "Braga - CC Braga Parque",
    address: {
      latitude: 41.55729609999999,
      longitude: -8.405997,
      phone: "+351 253 773 875",
      province: "Braga",
      address1: "Rua dos Congregados 1",
      address2: "",
      city: "Braga",
      country: "Portugal",
      zip: "4710-027",
      countryCode: "PT",
      hours:
        '[["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85775614166",
    name: "Brownie -  Mallorca",
    address: {
      latitude: 39.5729004,
      longitude: 2.6520277,
      phone: "+34 971 729 198",
      province: "Balears",
      address1: "San Miguel, 27",
      address2: "",
      city: "Palma de Mallorca",
      country: "Spain",
      zip: "07002",
      countryCode: "ES",
      hours:
        '[["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85775646934",
    name: "Brownie - Aeropuerto de Barcelona-El Prat",
    address: {
      latitude: 41.2875743,
      longitude: 2.0733063,
      phone: "+34 934 991 900",
      province: "Barcelona",
      address1: "Josep Tarradellas Barcelona-El Prat Airport, Terminal 1",
      address2: "",
      city: "El Prat de Llobregat",
      country: "Spain",
      zip: "08820",
      countryCode: "ES",
      hours:
        '[["06:00 a 21:00"],["06:00 a 21:00"],["06:00 a 21:00"],["06:00 a 21:00"],["06:00 a 21:00"],["06:00 a 21:00"],["06:00 a 21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85776498902",
    name: "Brownie - Alicante",
    address: {
      latitude: 38.3433193,
      longitude: -0.4894124,
      phone: "+34 96 589 90 28",
      province: "Alicante",
      address1: "Av. Maisonnave, 7",
      address2: "",
      city: "Alicante",
      country: "Spain",
      zip: "03003",
      countryCode: "ES",
      hours:
        '[["10:00 a 21:30"],["10:00 a 21:30"],["10:00 a 21:30"],["10:00 a 21:30"],["10:00 a 21:30"],["10:00 a 21:30"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85776531670",
    name: "Brownie - Amoreiras Shopping Center",
    address: {
      latitude: 38.7235062,
      longitude: -9.1616805,
      phone: "+351 215 833 289",
      province: "Lisboa",
      address1: "Av. Eng. Duarte Pacheco n° 2037",
      address2: "",
      city: "Lisboa",
      country: "Portugal",
      zip: "1070-103",
      countryCode: "PT",
      hours:
        '[["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85776564438",
    name: "Brownie - Armazéns do Chiado",
    address: {
      latitude: 38.7111375,
      longitude: -9.1396463,
      phone: "+351 213 421 410",
      province: "Lisboa",
      address1: "R. do Carmo,",
      address2: "Loja  5.17 e 5.18 Rua Do Carmo",
      city: "Lisboa",
      country: "Portugal",
      zip: "1200-094",
      countryCode: "PT",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85776597206",
    name: "Brownie - Artz Pedregal",
    address: {
      latitude: 19.3147738,
      longitude: -99.2204146,
      phone: "55 59293239",
      province: null,
      address1: "Periferico Sur 3720, Jardines del Pedregal, Álvaro Obregón",
      address2: "",
      city: "Ciudad de México",
      country: "Mexico",
      zip: "01900",
      countryCode: "MX",
      hours:
        '[["11:00 a 9:00"],["11:00 a 9:00"],["11:00 a 9:00"],["11:00 a 9:00"],["11:00 a 9:00"],["11:00 a 9:00"],["11:00 a 9:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85780037846",
    name: "Brownie - Bercy Village",
    address: {
      latitude: 48.83334079999999,
      longitude: 2.3870316,
      phone: "+33 143 423 243",
      province: null,
      address1: "46A Cour Saint Émilion",
      address2: "Bercy Village",
      city: "Paris",
      country: "France",
      zip: "75012",
      countryCode: "FR",
      hours:
        '[["10:00 a 20:00"],["10:00 a 20:00"],["10:00 a 20:00"],["10:00 a 20:00"],["10:00 a 20:00"],["10:00 a 20:00"],["10:00 a 20:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85776629974",
    name: "Brownie - Bilbao",
    address: {
      latitude: 43.26282,
      longitude: -2.9331422,
      phone: "+34 944 109 689",
      province: "Vizcaya",
      address1: "Calle de Gran Vía, 36",
      address2: "",
      city: "Bilbao",
      country: "Spain",
      zip: "48009",
      countryCode: "ES",
      hours:
        '[["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85776662742",
    name: "Brownie - CC Nervión Plaza",
    address: {
      latitude: 37.3845625,
      longitude: -5.9722972,
      phone: "+34 954 420 746",
      province: "Sevilla",
      address1: "C. Luis de Morales 3 - CC Nervión Plaza - LOCAL A023",
      address2: "",
      city: "Sevilla",
      country: "Spain",
      zip: "41005",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85776695510",
    name: "Brownie - CC Norte Shopping",
    address: {
      latitude: 41.1817172,
      longitude: -8.6543354,
      phone: "+351 224 000 532",
      province: "Porto",
      address1: "R. Sara Afonso",
      address2: "",
      city: "Porto",
      country: "Portugal",
      zip: "4460-841",
      countryCode: "PT",
      hours:
        '[["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85776728278",
    name: "Brownie - CC Zielo Shopping Pozuelo",
    address: {
      latitude: 40.441147,
      longitude: -3.786291,
      phone: "+34 917 443 550",
      province: "Madrid",
      address1: "Avda. de Europa,26 B local 114",
      address2: "",
      city: "Pozuelo de Alarcón",
      country: "Spain",
      zip: "28224",
      countryCode: "ES",
      hours:
        '[["10:00 a 21:30"],["10:00 a 21:30"],["10:00 a 21:30"],["10:00 a 21:30"],["10:00 a 21:30"],["10:00 a 21:30"],["12:00 a 20:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85776761046",
    name: "Brownie - CC. Illa Carlemany",
    address: {
      latitude: 42.5089935,
      longitude: 1.5349353,
      phone: "376862530",
      province: null,
      address1: "Av. Carlemany, 70",
      address2: "",
      city: "Escaldes-Engordany",
      country: "Andorra",
      zip: "AD700",
      countryCode: "AD",
      hours:
        '[["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 20:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85776793814",
    name: "Brownie - Centro Colombo",
    address: {
      latitude: 38.7533614,
      longitude: -9.1890765,
      phone: "+351 211 621 389",
      province: "Lisboa",
      address1: "Av. Lusíada",
      address2: "",
      city: "Lisboa",
      country: "Portugal",
      zip: "1500-392",
      countryCode: "PT",
      hours:
        '[["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 15:30"],["10:00 a 15:30"]]',
    },
  },
  {
    id: "gid://shopify/Location/85776826582",
    name: "Brownie - El Corte Inglés  Lisboa",
    address: {
      latitude: 38.73280070000001,
      longitude: -9.153139399999999,
      phone: "+351 211 930 546",
      province: "Lisboa",
      address1: "Av. António Augusto de Aguiar 31",
      address2: "",
      city: "Lisboa",
      country: "Portugal",
      zip: "1069-413",
      countryCode: "PT",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 23:30"],["10:00 a 23:30"],["10:00 a 20:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85776859350",
    name: "Brownie - El Corte Inglés Bercial",
    address: {
      latitude: 40.3296743,
      longitude: -3.7286105,
      phone: "+34 915 563 209",
      province: "Madrid",
      address1: "Av. Comandante José Manuel Ripollés, 2",
      address2: "",
      city: "Getafe",
      country: "Spain",
      zip: "28905",
      countryCode: "ES",
      hours:
        '[["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85776892118",
    name: "Brownie - El Corte Inglés Plaza Cataluña",
    address: {
      latitude: 41.3879159,
      longitude: 2.1711725,
      phone: "+34 934 069 834",
      province: "Barcelona",
      address1: "Plaza Cataluña, 14",
      address2: "",
      city: "Barcelona",
      country: "Spain",
      zip: "08002",
      countryCode: "ES",
      hours:
        '[["9:00  a  21:00"],["9:00  a  21:00"],["9:00  a  21:00"],["9:00  a  21:00"],["9:00  a  21:00"],["9:00  a  21:00"],[""]]',
    },
  },
  {
    id: "gid://shopify/Location/85776924886",
    name: "Brownie - El Corte Inglés Salamanca",
    address: {
      latitude: 40.9737426,
      longitude: -5.6574623,
      phone: "+34 923 347 373",
      province: "Salamanca",
      address1: "C. María Auxiliadora, 71-85",
      address2: "",
      city: "Salamanca",
      country: "Spain",
      zip: "37004",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85776957654",
    name: "Brownie - El Corte Inglés Uría",
    address: {
      latitude: 43.36368390000001,
      longitude: -5.8517871,
      phone: "+34 985 798 202",
      province: "Asturias",
      address1: "C. Uría, 9",
      address2: "",
      city: "Oviedo",
      country: "Spain",
      zip: "33003",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],[""]]',
    },
  },
  {
    id: "gid://shopify/Location/85776990422",
    name: "Brownie - El Corte Inglés Vigo",
    address: {
      latitude: 42.2321047,
      longitude: -8.717294599999999,
      phone: "+34 986 422 793",
      province: "Pontevedra",
      address1: "Av. da Gran Vía, 25",
      address2: "",
      city: "Vigo",
      country: "Spain",
      zip: "36203",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],[""]]',
    },
  },
  {
    id: "gid://shopify/Location/85777023190",
    name: "Brownie - El Corte Inglés Zaragoza",
    address: {
      latitude: 41.6453333,
      longitude: -0.8849442,
      phone: "+34 976 591 939",
      province: "Zaragoza",
      address1: "Paseo de Sagasta 3",
      address2: "",
      city: "Zaragoza",
      country: "Spain",
      zip: "50008",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],[""]]',
    },
  },
  {
    id: "gid://shopify/Location/85777055958",
    name: "Brownie - Falabella La Dehesa",
    address: {
      latitude: -33.3573513,
      longitude: -70.5151516,
      phone: null,
      province: null,
      address1: "Av. La Dehesa 1445,  Santiago",
      address2: "",
      city: "Santiago, Lo Barnechea, Región Metropolitana",
      country: "Chile",
      zip: "7690130",
      countryCode: "CL",
      hours:
        '[["10:00 a 20:00"],["10:00 a 20:00"],["10:00 a 20:00"],["10:00 a 20:00"],["10:00 a 20:00"],["10:00 a 20:00"],["11:00 a 20:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777088726",
    name: "Brownie - Forum Aveiro",
    address: {
      latitude: 40.641013,
      longitude: -8.6534576,
      phone: "+351 234 136 557",
      province: "Aveiro",
      address1: "R. do Batalhão de Caçadores 10 Store 2.2a",
      address2: "",
      city: "Aveiro",
      country: "Portugal",
      zip: "3810-065",
      countryCode: "PT",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777121494",
    name: "Brownie - Francesc Macià - Diagonal",
    address: {
      latitude: 41.3936,
      longitude: 2.1465842,
      phone: "+34 932 777 307",
      province: "Barcelona",
      address1: "Av. Diagonal 588",
      address2: "",
      city: "Barcelona",
      country: "Spain",
      zip: "08021",
      countryCode: "ES",
      hours:
        '[["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["12:00 a 20:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777154262",
    name: "Brownie - Fuencarral",
    address: {
      latitude: 40.4244208,
      longitude: -3.7008983,
      phone: "+34 914 497 530",
      province: "Madrid",
      address1: "Calle de Fuencarral, 61",
      address2: "",
      city: "Madrid",
      country: "Spain",
      zip: "28004",
      countryCode: "ES",
      hours:
        '[["10:30 a 21:00"],["10:30 a 21:00"],["10:30 a 21:00"],["10:30 a 21:00"],["10:30 a 21:00"],["10:30 a 21:00"],["12:00 a 20:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777187030",
    name: "Brownie - Garbera",
    address: {
      latitude: 43.308764,
      longitude: -1.9447431,
      phone: "+34 943 788 502",
      province: "Guipúzcoa",
      address1: "Calle Garbera 1 1(N1/A8, 5 Irteera INTXAURRONDO), local 137",
      address2: "",
      city: "Donostia-San Sebastián",
      country: "Spain",
      zip: "20017",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777219798",
    name: "Brownie - Hermosilla",
    address: {
      latitude: 40.4262024,
      longitude: -3.6849109,
      phone: "+34 911 377 877",
      province: "Madrid",
      address1: "Calle Hermosilla, 26",
      address2: "",
      city: "Madrid",
      country: "Spain",
      zip: "28001",
      countryCode: "ES",
      hours:
        '[["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["12:00 a 20:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85677179094",
    name: "Brownie - L'Illa Diagonal",
    address: {
      latitude: 41.3895578,
      longitude: 2.1355779,
      phone: "+34934109078",
      province: "Barcelona",
      address1: "Avinguda Diagonal 577",
      address2: "",
      city: "Barcelona",
      country: "Spain",
      zip: "08029",
      countryCode: "ES",
      hours:
        '[["09:30 a 21:30"],["09:30 a 21:30"],["09:30 a 21:30"],["09:30 a 21:30"],["09:30 a 21:30"],["09:30 a 21:30"],["12:00 a 20:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777252566",
    name: "Brownie - La Coruña",
    address: {
      latitude: 43.36610839999999,
      longitude: -8.406070399999999,
      phone: "+34 881 088010",
      province: "A Coruña",
      address1: "Plaza de Lugo 24",
      address2: "",
      city: "Coruña",
      country: "Spain",
      zip: "15004",
      countryCode: "ES",
      hours:
        '[["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777285334",
    name: "Brownie - La Moraleja Green",
    address: {
      latitude: 40.5177561,
      longitude: -3.6581828,
      phone: "+34 917 296 979",
      province: "Madrid",
      address1: "Avda. de Europa 13 1ºPlta",
      address2: "Centro Comercial La Moraleja Green (Edificio Norte)",
      city: "Alcobendas",
      country: "Spain",
      zip: "28108",
      countryCode: "ES",
      hours:
        '[["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["12:00 a 20:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777318102",
    name: "Brownie - Lagasca",
    address: {
      latitude: 40.4283715,
      longitude: -3.6848217,
      phone: "+34 914 354 498",
      province: "Madrid",
      address1: "Calle Lagasca, 72",
      address2: "",
      city: "Madrid",
      country: "Spain",
      zip: "28001",
      countryCode: "ES",
      hours:
        '[["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["12:00 a 20:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85780103382",
    name: "Brownie - Le Marais",
    address: {
      latitude: 48.85636119999999,
      longitude: 2.3616321,
      phone: "+33 140 245 964",
      province: null,
      address1: "18 Rue Malher",
      address2: "",
      city: "Paris",
      country: "France",
      zip: "75004",
      countryCode: "FR",
      hours:
        '[["10:00 a 20:00"],["10:00 a 20:00"],["10:00 a 20:00"],["10:00 a 20:00"],["10:00 a 20:00"],["10:00 a 20:00"],["11:00 a 19:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777350870",
    name: "Brownie - Mandri",
    address: {
      latitude: 41.4032669,
      longitude: 2.1335258,
      phone: "+34 932 115 621",
      province: "Barcelona",
      address1: "Calle Mandri 33",
      address2: "",
      city: "Barcelona",
      country: "Spain",
      zip: "08022",
      countryCode: "ES",
      hours:
        '[["10:00 a 14:00 y 16:30 a 20:30"],["10:00 a 14:00 y 16:30 a 20:30"],["10:00 a 14:00 y 16:30 a 20:30"],["10:00 a 14:00 y 16:30 a 20:30"],["10:00 a 14:00 y 16:30 a 20:30"],["10:30 a 14:00 y 16:30 a 20:30"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777383638",
    name: "Brownie - Mar Shopping",
    address: {
      latitude: 41.2079316,
      longitude: -8.6895873,
      phone: "+351 221 182 039",
      province: "Porto",
      address1: "Loja 1.36 - Av. Dr. Óscar Lopes",
      address2: "",
      city: "Matosinhos",
      country: "Portugal",
      zip: "4450-337",
      countryCode: "PT",
      hours:
        '[["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777416406",
    name: "Brownie - Marques Soares",
    address: {
      latitude: 41.1464424,
      longitude: -8.6142716,
      phone: "+351 222 022 222",
      province: "Porto",
      address1: "R. das Carmelitas, 80",
      address2: "",
      city: "Porto",
      country: "Portugal",
      zip: "4050-161",
      countryCode: "PT",
      hours:
        '[["10:00 a 13:30 y 14:30 a 19:00"],["10:00 a 13:30 y 14:30 a 19:00"],["10:00 a 13:30 y 14:30 a 19:00"],["10:00 a 13:30 y 14:30 a 19:00"],["10:00 a 13:30 y 14:30 a 19:00"],["10:00 a 13:30 y 14:30 a 19:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777449174",
    name: "Brownie - Oeiras Parque",
    address: {
      latitude: 38.7039407,
      longitude: -9.3009889,
      phone: "+351 214 460 050",
      province: "Lisboa",
      address1: "Av. António Bernardo Cabral de Macedo",
      address2: "",
      city: "OEIRAS",
      country: "Portugal",
      zip: "2770-219",
      countryCode: "PT",
      hours:
        '[["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"],["10:00 a 23:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777481942",
    name: "Brownie - Oviedo",
    address: {
      latitude: 43.362941,
      longitude: -5.8494636,
      phone: "+34 985 757 567",
      province: "Asturias",
      address1: "Uría, 16",
      address2: "",
      city: "Oviedo",
      country: "Spain",
      zip: "33003",
      countryCode: "ES",
      hours:
        '[["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777514710",
    name: "Brownie - Pamplona",
    address: {
      latitude: 42.8141672,
      longitude: -1.6399912,
      phone: "+34 948 924 923",
      province: "Navarra",
      address1: "Avenida Carlos III el Noble 23",
      address2: "",
      city: "Pamplona",
      country: "Spain",
      zip: "31002",
      countryCode: "ES",
      hours:
        '[["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["12:00 a 20:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777547478",
    name: "Brownie - PDH Durango",
    address: {
      latitude: 19.4188205,
      longitude: -99.1688817,
      phone: "55 5242 9000",
      province: null,
      address1: "Calle de Durango 230, Roma Nte.",
      address2: "Cuauhtémoc",
      city: "Ciudad de México",
      country: "Afghanistan",
      zip: "06700",
      countryCode: "AF",
      hours:
        '[["11:00a21:00"],["11:00a21:00"],["11:00a21:00"],["11:00a21:00"],["11:00a21:00"],["11:00a21:00"],["11:00a21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777580246",
    name: "Brownie - PDH Interlomas",
    address: {
      latitude: 19.3974855,
      longitude: -99.2823698,
      phone: "55 4428 4400",
      province: null,
      address1:
        "Vialidad de la Barranca 6, Col. Ex Hacienda Jesús del Monte, Bosque de las Palmas",
      address2: "",
      city: "Naucalpan de Juárez",
      country: "Afghanistan",
      zip: "52787",
      countryCode: "AF",
      hours:
        '[["11:00a21:00"],["11:00a21:00"],["11:00a21:00"],["11:00a21:00"],["11:00a21:00"],["11:00a21:00"],["11:00a21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777613014",
    name: "Brownie - PDH Perisur",
    address: {
      latitude: 19.3079512,
      longitude: -99.1968277,
      phone: "55 5447 1600",
      province: null,
      address1: "Anillo Periférico 4690",
      address2: "",
      city: "Jardines del Pedregal de San Ángel",
      country: "Afghanistan",
      zip: "04500",
      countryCode: "AF",
      hours:
        '[["11:00a21:00"],["11:00a21:00"],["11:00a21:00"],["11:00a21:00"],["11:00a21:00"],["11:00a21:00"],["11:00a21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777645782",
    name: "Brownie - PDH Polanco",
    address: {
      latitude: 19.4356367,
      longitude: -99.2021931,
      phone: "55 5283 7200",
      province: null,
      address1: "Av Moliere 222, Polanco, Polanco II Secc",
      address2: "",
      city: "Miguel Hidalgo",
      country: "Afghanistan",
      zip: "11530",
      countryCode: "AF",
      hours:
        '[["11:00a21:00"],["11:00a21:00"],["11:00a21:00"],["11:00a21:00"],["11:00a21:00"],["11:00a21:00"],["11:00a21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777678550",
    name: "Brownie - PDH Puebla",
    address: {
      latitude: 19.024982,
      longitude: -98.2284755,
      phone: "22 2273 8800",
      province: null,
      address1: "Boulevard del Niño Poblano Concepción la Cruz 2510",
      address2: "",
      city: "Concepción Guadalupe",
      country: "Afghanistan",
      zip: "72450",
      countryCode: "AF",
      hours:
        '[["11:00a21:00"],["11:00a21:00"],["11:00a21:00"],["11:00a21:00"],["11:00a21:00"],["11:00a21:00"],["11:00a21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777711318",
    name: "Brownie - PDH Santa Fe",
    address: {
      latitude: 19.3594791,
      longitude: -99.2707271,
      phone: "55 5257 9200",
      province: null,
      address1: "Lomas de Santa Fe, Lomas de Vista Hermosa",
      address2: "",
      city: "Cuajimalpa de Morelos",
      country: "Afghanistan",
      zip: "05349",
      countryCode: "AF",
      hours:
        '[["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777744086",
    name: "Brownie - Praça do Rossio",
    address: {
      latitude: 38.7141692,
      longitude: -9.138866,
      phone: "+351 213 421 467",
      province: "Lisboa",
      address1: "Praça do Rossio 88",
      address2: "",
      city: "Lisboa",
      country: "Portugal",
      zip: "1100-200",
      countryCode: "PT",
      hours:
        '[["10:00 a 21:30"],["10:00 a 21:30"],["10:00 a 21:30"],["10:00 a 21:30"],["10:00 a 21:30"],["10:00 a 21:30"],["11:00 a 21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777776854",
    name: "Brownie - Puerto Venecia",
    address: {
      latitude: 41.6092467,
      longitude: -0.8853168,
      phone: "+34 976 100 021",
      province: "Zaragoza",
      address1: "C/ Travesía Jardines Reales, 7. Local nº 11 Puerto Venecia",
      address2: "",
      city: "Zaragoza",
      country: "Spain",
      zip: "50021",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],[""]]',
    },
  },
  {
    id: "gid://shopify/Location/85777842390",
    name: "Brownie - Rambla Cataluña",
    address: {
      latitude: 41.3924946,
      longitude: 2.1619281,
      phone: "+34 934 619 210",
      province: "Barcelona",
      address1: "Rambla Cataluña, 80",
      address2: "",
      city: "Barcelona",
      country: "Spain",
      zip: "08008",
      countryCode: "ES",
      hours:
        '[["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["12:00 a 20:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777875158",
    name: "Brownie - Rue de Rennes",
    address: {
      latitude: 48.8514334,
      longitude: 2.3305573,
      phone: "+33 143 351 430",
      province: null,
      address1: "74 Rue de Rennes",
      address2: "",
      city: "París",
      country: "France",
      zip: "75006",
      countryCode: "FR",
      hours:
        '[["10:00 a 20:00"],["10:00 a 20:00"],["10:00 a 20:00"],["10:00 a 20:00"],["10:00 a 20:00"],["10:00 a 20:00"],["12:00 a 19:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777907926",
    name: "Brownie - Salamanca",
    address: {
      latitude: 40.9683035,
      longitude: -5.6605098,
      phone: "+34 923 384 421",
      province: "Salamanca",
      address1: "Calle Toro 84",
      address2: "",
      city: "Salamanca",
      country: "Spain",
      zip: "37002",
      countryCode: "ES",
      hours:
        '[["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777940694",
    name: "Brownie - San Sebastián",
    address: {
      latitude: 43.3187281,
      longitude: -1.9832361,
      phone: "+34 943 272 629",
      province: "Guipúzcoa",
      address1: "Calle Loiola Kalea, 4",
      address2: "",
      city: "Donostia",
      country: "Spain",
      zip: "20005",
      countryCode: "ES",
      hours:
        '[["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85777973462",
    name: "Brownie - Sant Cugat",
    address: {
      latitude: 41.4724692,
      longitude: 2.0833648,
      phone: "+34 935 894 332",
      province: "Barcelona",
      address1: "Calle Santiago Rusiñol, 36",
      address2: "local 1",
      city: "Sant Cugat del Valles",
      country: "Spain",
      zip: "08172",
      countryCode: "ES",
      hours:
        '[["10:00 a 14:00 y 16:30 a 20:30"],["10:00 a 14:00 y 16:30 a 20:30"],["10:00 a 14:00 y 16:30 a 20:30"],["10:00 a 14:00 y 16:30 a 20:30"],["10:00 a 14:00 y 16:30 a 20:30"],["10:00 a 14:00 y 16:30 a 20:30"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778006230",
    name: "Brownie - Santaló",
    address: {
      latitude: 41.3961257,
      longitude: 2.1450514,
      phone: "+34 932 004 790",
      province: "Barcelona",
      address1: "Calle Santaló, 43",
      address2: "",
      city: "Barcelona",
      country: "Spain",
      zip: "08021",
      countryCode: "ES",
      hours:
        '[["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:30 a 20:30"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778038998",
    name: "Brownie - Santander",
    address: {
      latitude: 43.4619734,
      longitude: -3.8081867,
      phone: "+34 942 065 403",
      province: "Cantabria",
      address1: "Calle Juan Herrera 12",
      address2: "",
      city: "Santander",
      country: "Spain",
      zip: "39002",
      countryCode: "ES",
      hours:
        '[["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778071766",
    name: "Brownie - Sevilla",
    address: {
      latitude: 37.3910512,
      longitude: -5.9959359,
      phone: "+34 954 91 2940",
      province: "Sevilla",
      address1: "Calle Rioja, 16",
      address2: "",
      city: "Sevilla",
      country: "Spain",
      zip: "41001",
      countryCode: "ES",
      hours:
        '[["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778104534",
    name: "Brownie - Tel Aviv",
    address: {
      latitude: 32.0683185,
      longitude: 34.7835324,
      phone: null,
      province: null,
      address1: "TLV Mall, Carlebach St 4, Tel Aviv-Yafo",
      address2: "",
      city: "Tel Aviv",
      country: "Israel",
      zip: "6713208",
      countryCode: "IL",
      hours:
        '[["10:00 a 21:30"],["10:00 a 21:30"],["10:00 a 21:30"],["10:00 a 21:30"],["9:00  a  16:00"],["20:00 a 23:00"],["10:00 a 21:30"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778137302",
    name: "Brownie - Valencia",
    address: {
      latitude: 39.469535,
      longitude: -0.3693775,
      phone: "+34 963 944 751",
      province: "Valencia",
      address1: "Calle Jorge Juan, 13",
      address2: "",
      city: "Valencia",
      country: "Spain",
      zip: "46004",
      countryCode: "ES",
      hours:
        '[["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778170070",
    name: "Brownie - Valencia Aqua",
    address: {
      latitude: 39.4566515,
      longitude: -0.345862,
      phone: "+34 962 955 679",
      province: "Valencia",
      address1: "Carrer de Menorca, 19",
      address2: "",
      city: "València",
      country: "Spain",
      zip: "46023",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778202838",
    name: "Brownie - Valladolid",
    address: {
      latitude: 41.6495866,
      longitude: -4.7289822,
      phone: "+34 983 384 056",
      province: "Valladolid",
      address1: "Calle Santiago 21",
      address2: "",
      city: "Valladolid",
      country: "Spain",
      zip: "47001",
      countryCode: "ES",
      hours:
        '[["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778235606",
    name: "Brownie - Vélizy",
    address: {
      latitude: 48.7813323,
      longitude: 2.2200138,
      phone: "+33 161 120 374",
      province: null,
      address1: "2 avenue de l’Europe",
      address2: "Centre Commercial Vélizy 2",
      city: "Vélizy-Villacoublay",
      country: "France",
      zip: "78140",
      countryCode: "FR",
      hours:
        '[["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 19:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778268374",
    name: "Brownie - Vigo",
    address: {
      latitude: 42.2371537,
      longitude: -8.723773099999999,
      phone: "+34 886 908 035",
      province: "Pontevedra",
      address1: "Rúa do Príncipe, 18",
      address2: "",
      city: "Vigo",
      country: "Spain",
      zip: "36202",
      countryCode: "ES",
      hours:
        '[["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778301142",
    name: "Brownie - Zaragoza",
    address: {
      latitude: 41.6498875,
      longitude: -0.8828395000000001,
      phone: null,
      province: "Zaragoza",
      address1: "Paseo de la Independencia, 27",
      address2: "",
      city: "Zaragoza",
      country: "Spain",
      zip: "50001",
      countryCode: "ES",
      hours:
        '[["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778333910",
    name: "Brownie Pyrénées Andorra",
    address: {
      latitude: 42.50787,
      longitude: 1.5236546,
      phone: "+376 880 000",
      province: null,
      address1: "Avenida Meritxell, 11",
      address2: "1r piso, Moda Dona",
      city: "Andorra la Vella",
      country: "Andorra",
      zip: "AD500",
      countryCode: "AD",
      hours:
        '[["9:30 a 21:00"],["9:30 a 21:00"],["9:30 a 21:00"],["9:30 a 21:00"],["9:30 a 21:00"],["9:30 a 21:00"],["9:30 a 20:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778366678",
    name: "El Corte Inglés  - Bilbao",
    address: {
      latitude: 43.2618376,
      longitude: -2.9295656,
      phone: "+34 944 253 500",
      province: "Vizcaya",
      address1: "Don Diego López Haroko Kale Nagusia,",
      address2: "",
      city: "Bilbao",
      country: "Spain",
      zip: "48001",
      countryCode: "ES",
      hours:
        '[["09:30 a 21:00"],["09:30 a 21:00"],["09:30 a 21:00"],["09:30 a 21:00"],["09:30 a 21:00"],["09:30 a 21:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778399446",
    name: "El Corte Inglés  - Castellana",
    address: {
      latitude: 40.4468,
      longitude: -3.6945,
      phone: "+34 917 709 261",
      province: "Madrid",
      address1: "Calle de Raimundo Fernández Villaverde, 79",
      address2: "",
      city: "Madrid",
      country: "Spain",
      zip: "28003",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["11:00 a 21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778464982",
    name: "El Corte Inglés  - Duque",
    address: {
      latitude: 37.3932508,
      longitude: -5.9963295,
      phone: "+34 955 722 746",
      province: "Sevilla",
      address1: "Pl. del Duque de la Victoria, 8",
      address2: "",
      city: "Sevilla",
      country: "Spain",
      zip: "41002",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["11:00 a 21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778497750",
    name: "El Corte Inglés  - Granada",
    address: {
      latitude: 37.1706919,
      longitude: -3.5978378,
      phone: "+34 958 215 928",
      province: "Granada",
      address1: "Carrera de la Virgen 20-22",
      address2: "",
      city: "Granada",
      country: "Spain",
      zip: "18005",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778530518",
    name: "El Corte Inglés  - Málaga",
    address: {
      latitude: 36.7174789,
      longitude: -4.4286593,
      phone: "+34 952 396 598",
      province: "Málaga",
      address1: "Av. de Andalucía, 4",
      address2: "",
      city: "Málaga",
      country: "Spain",
      zip: "29007",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85780201686",
    name: "El Corte Inglés  - Murcia",
    address: {
      latitude: 37.9412674,
      longitude: -1.1685602,
      phone: "+34 968 404 451",
      province: "Murcia",
      address1: "Av. de la Libertad, 1",
      address2: "",
      city: "Murcia",
      country: "Spain",
      zip: "30120",
      countryCode: "ES",
      hours: '[[""],[""],[""],[""],[""],[""],[""]]',
    },
  },
  {
    id: "gid://shopify/Location/85778563286",
    name: "El Corte Inglés  - Pintor Sorolla",
    address: {
      latitude: 39.469512,
      longitude: -0.3723343,
      phone: "+34 963 159 500",
      province: "Valencia",
      address1: "Carrer de Colón, 27",
      address2: "",
      city: "València",
      country: "Spain",
      zip: "46004",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778596054",
    name: "El Corte Inglés  - Preciados",
    address: {
      latitude: 40.417669,
      longitude: -3.7048433,
      phone: "+34 913 798 000",
      province: "Madrid",
      address1: "Calle de Preciados, 3",
      address2: "",
      city: "Madrid",
      country: "Spain",
      zip: "28013",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["11:00 a 21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778661590",
    name: "El Corte Inglés -  Gaia Porto",
    address: {
      latitude: 41.1254595,
      longitude: -8.6049018,
      phone: "+351 223 781 400",
      province: "Porto",
      address1: "Av. da República 1435",
      address2: "",
      city: "Vila Nova de Gaia",
      country: "Portugal",
      zip: "4430-999",
      countryCode: "PT",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 23:30"],["10:00 a 23:30"],["10:00 a 20:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778694358",
    name: "El Corte Inglés - Albacete",
    address: {
      latitude: 38.9827445,
      longitude: -1.8542399,
      phone: "+34 967 482 961",
      province: "Albacete",
      address1: "Av. de España, 30",
      address2: "",
      city: "Albacete",
      country: "Spain",
      zip: "02002",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],[""]]',
    },
  },
  {
    id: "gid://shopify/Location/85778727126",
    name: "El Corte Inglés - Alicante",
    address: {
      latitude: 38.3430346,
      longitude: -0.4934513,
      phone: "+34 966 902 298",
      province: "Alicante",
      address1: "Av. Maisonnave, 53",
      address2: "",
      city: "Alicante",
      country: "Spain",
      zip: "03003",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778759894",
    name: "El Corte Inglés - Burgos",
    address: {
      latitude: 42.3185041,
      longitude: -3.703607799999999,
      phone: "+34 947 538 917",
      province: "Burgos",
      address1: "Ctra. Madrid-Irún, Km 236",
      address2: "",
      city: "Burgos",
      country: "Spain",
      zip: "09001",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],[""]]',
    },
  },
  {
    id: "gid://shopify/Location/85778792662",
    name: "El Corte Inglés - Castellón",
    address: {
      latitude: 39.9878013,
      longitude: -0.0479689,
      phone: "+34 964 344 150",
      province: "Castellón",
      address1: "Pº de Morella, 1",
      address2: "",
      city: "Castellón de la Plana",
      country: "Spain",
      zip: "12006",
      countryCode: "ES",
      hours:
        '[["10:00a22:00"],["10:00a22:00"],["10:00a22:00"],["10:00a22:00"],["10:00a22:00"],["10:00a22:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778825430",
    name: "El Corte Inglés - Córdoba",
    address: {
      latitude: 37.8957817,
      longitude: -4.8038473,
      phone: "+34 957 304 879",
      province: "Córdoba",
      address1: "Ctra. Sta. M° de Trassierra, A-3050 s/n",
      address2: "",
      city: "Córdoba",
      country: "Spain",
      zip: "14011",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778858198",
    name: "El Corte Inglés - Coruña",
    address: {
      latitude: 43.3347518,
      longitude: -8.4674243,
      phone: "+34 981 306 980",
      province: "A Coruña",
      address1: "Rua Ramon y Cajal 57-59",
      address2: "",
      city: "Coruña",
      country: "Spain",
      zip: "15006",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778890966",
    name: "El Corte Inglés - Diagonal",
    address: {
      latitude: 41.3873281,
      longitude: 2.1276958,
      phone: "+34 935 842 369",
      province: "Barcelona",
      address1: "Avinguda Diagonal, 617",
      address2: "",
      city: "Barcelona",
      country: "Spain",
      zip: "08028",
      countryCode: "ES",
      hours:
        '[["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778923734",
    name: "El Corte Inglés - Gijón",
    address: {
      latitude: 43.5240391,
      longitude: -5.6789936,
      phone: "+34 985 160 694",
      province: "Asturias",
      address1: "C. Ramón Areces 2",
      address2: "",
      city: "Gijón",
      country: "Spain",
      zip: "33211",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],[""]]',
    },
  },
  {
    id: "gid://shopify/Location/85778956502",
    name: "El Corte Inglés - Goya",
    address: {
      latitude: 40.4249626,
      longitude: -3.6763212,
      phone: "+34 914 329 300",
      province: "Madrid",
      address1: "Calle de Goya, 87",
      address2: "",
      city: "Madrid",
      country: "Spain",
      zip: "28001",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["11:00 a 21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85778989270",
    name: "El Corte Inglés - Jerez",
    address: {
      latitude: 36.70547,
      longitude: -6.116401499999999,
      phone: "+34 956 396 960",
      province: "Cádiz",
      address1: "Av. Andalucía, 34",
      address2: "",
      city: "Jerez",
      country: "Spain",
      zip: "11407",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],[""]]',
    },
  },
  {
    id: "gid://shopify/Location/85779022038",
    name: "El Corte Inglés - Las Palmas",
    address: {
      latitude: 28.1344566,
      longitude: -15.4317474,
      phone: "+34 928 263 000",
      province: "Las Palmas",
      address1: "Av. José Mesa y López 13",
      address2: "",
      city: "Las Palmas de Gran Canaria",
      country: "Spain",
      zip: "35007",
      countryCode: "ES",
      hours:
        '[["09:30 a 21:30"],["09:30 a 21:30"],["09:30 a 21:30"],["09:30 a 21:30"],["09:30 a 21:30"],["09:30 a 21:30"],[""]]',
    },
  },
  {
    id: "gid://shopify/Location/85779054806",
    name: "El Corte Inglés - León",
    address: {
      latitude: 42.590695,
      longitude: -5.5691118,
      phone: "+34 987 263 100",
      province: "León",
      address1: "Calle Fray Luis de León, 29",
      address2: "",
      city: "León",
      country: "Spain",
      zip: "24005",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85779087574",
    name: "El Corte Inglés - Marbella",
    address: {
      latitude: 36.4903846,
      longitude: -4.9520721,
      phone: "+34 952 909 990",
      province: "Málaga",
      address1: "Calle Ramón Areces",
      address2: "",
      city: "Marbella",
      country: "Spain",
      zip: "29660",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85779120342",
    name: "El Corte Inglés - Murcia",
    address: {
      latitude: 37.9902272,
      longitude: -1.134361,
      phone: "+34 968 404 451",
      province: "Murcia",
      address1: "Avda. de la Libertad, 1",
      address2: "P3",
      city: "Murcia",
      country: "Spain",
      zip: "30009",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],[""]]',
    },
  },
  {
    id: "gid://shopify/Location/85779153110",
    name: "El Corte Inglés - Palma de Mallorca",
    address: {
      latitude: 39.5736389,
      longitude: 2.6566226,
      phone: "+34 971 373 502",
      province: "Balears",
      address1: "Avenida Alexandre Roselló 12-16",
      address2: "",
      city: "Palma de Mallorca",
      country: "Spain",
      zip: "07002",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85779185878",
    name: "El Corte Inglés - Pamplona",
    address: {
      latitude: 42.8137674,
      longitude: -1.6452657,
      phone: "+34 948 235 499",
      province: "Navarra",
      address1: "C/Estella 9",
      address2: "",
      city: "Pamplona",
      country: "Spain",
      zip: "31002",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85779218646",
    name: "El Corte Inglés - Pozuelo",
    address: {
      latitude: 40.4189645,
      longitude: -3.7117806,
      phone: "+34 917 089 200",
      province: "Madrid",
      address1: "Carretera Nacional VI, Km. 12,500, 28224",
      address2: "",
      city: "Madrid",
      country: "Spain",
      zip: "28013",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["11:00 a 21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85779284182",
    name: "El Corte Inglés - Princesa",
    address: {
      latitude: 40.4295985,
      longitude: -3.7148732,
      phone: "+34 912 191 066",
      province: "Madrid",
      address1: "C. de la Princesa, 56, Centro",
      address2: "",
      city: "Madrid",
      country: "Spain",
      zip: "28008",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["11:00 a 21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85779316950",
    name: "El Corte Inglés - Sanchinarro",
    address: {
      latitude: 40.4975064,
      longitude: -3.6626631,
      phone: "+34 913 848 200",
      province: "Madrid",
      address1: "Calle Margarita de Parma, 1",
      address2: "",
      city: "Madrid",
      country: "Spain",
      zip: "28050",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["11:00 a 21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85779349718",
    name: "El Corte Inglés - Santander",
    address: {
      latitude: 43.4399022,
      longitude: -3.8449204,
      phone: "+34 942 378 581",
      province: "Cantabria",
      address1: "Av. Nueva Montaña, s/n",
      address2: "",
      city: "Santander",
      country: "Spain",
      zip: "39011",
      countryCode: "ES",
      hours:
        '[["09:30 a 21:30"],["09:30 a 21:30"],["09:30 a 21:30"],["09:30 a 21:30"],["09:30 a 21:30"],["09:30 a 21:30"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85779382486",
    name: "El Corte Inglés - Santiago de Compostela",
    address: {
      latitude: 42.8625529,
      longitude: -8.5432796,
      phone: null,
      province: "A Coruña",
      address1: "Rúa do Restollal, 50",
      address2: "",
      city: "Santiago de Compostela",
      country: "Spain",
      zip: "15702",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85779415254",
    name: "El Corte Inglés - Sevilla Nervión",
    address: {
      latitude: 37.3866987,
      longitude: -5.971607499999999,
      phone: "+34 955 780 096",
      province: "Sevilla",
      address1: "C/ Luis Montoto, 122",
      address2: "",
      city: "Sevilla",
      country: "Spain",
      zip: "41005",
      countryCode: "ES",
      hours:
        '[["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],["10:00 a 22:00"],[""]]',
    },
  },
  {
    id: "gid://shopify/Location/86555853014",
    name: "El Corte Inglés - Tarragona",
    address: {
      latitude: 41.1216663,
      longitude: 1.2423326,
      phone: "977 312 365",
      province: "Tarragona",
      address1: "Rambla President Lluís Companys, 7",
      address2: "",
      city: "Tarragona",
      country: "Spain",
      zip: "43005",
      countryCode: "ES",
      hours:
        '[["09:00 - 21:00"],["09:00 - 21:00"],["09:00 - 21:00"],["09:00 - 21:00"],["09:00 - 21:00"],["09:00 - 21:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85779448022",
    name: "El Corte Inglés - Tenerife",
    address: {
      latitude: 28.4590834,
      longitude: -16.2543289,
      phone: null,
      province: "Santa Cruz de Tenerife",
      address1: "Av. Tres de Mayo nº7",
      address2: "",
      city: "Santa Cruz de Tenerife",
      country: "Spain",
      zip: "38003",
      countryCode: "ES",
      hours:
        '[["09:30 a 21:30"],["09:30 a 21:30"],["09:30 a 21:30"],["09:30 a 21:30"],["09:30 a 21:30"],["09:30 a 21:30"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85779480790",
    name: "El Corte Inglés - Valladolid",
    address: {
      latitude: 41.6374111,
      longitude: -4.7401227,
      phone: "+34 983 231 500",
      province: "Valladolid",
      address1: "Paseo Zorrilla 130",
      address2: "",
      city: "Valladolid",
      country: "Spain",
      zip: "47006",
      countryCode: "ES",
      hours:
        '[["09:30 a 21:30"],["09:30 a 21:30"],["09:30 a 21:30"],["09:30 a 21:30"],["09:30 a 21:30"],["09:30 a 21:30"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85779513558",
    name: "El Corte Inglés - Vitoria",
    address: {
      latitude: 42.84467960000001,
      longitude: -2.6678633,
      phone: "+34 945 266 333",
      province: "Álava",
      address1: "Bake Kalea, 2",
      address2: "",
      city: "Vitoria-Gasteiz",
      country: "Spain",
      zip: "01004",
      countryCode: "ES",
      hours:
        '[["09:30 a 21:30"],["09:30 a 21:30"],["09:30 a 21:30"],["09:30 a 21:30"],["09:30 a 21:30"],["10:00 a 22:00"],["Cerrado"]]',
    },
  },
  {
    id: "gid://shopify/Location/85779546326",
    name: "Liverpool  - Oaxaca",
    address: {
      latitude: 17.0440506,
      longitude: -96.7153785,
      phone: null,
      province: "Oaxaca",
      address1: "Jorge L. Tamayo Castellanos 500",
      address2: "Agencia Candiani C.P, Universidad, Exhacienda Candiani",
      city: "Oaxaca de Juárez",
      country: "Mexico",
      zip: "68130",
      countryCode: "MX",
      hours:
        '[["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85779611862",
    name: "Liverpool -  Santa Fe",
    address: {
      latitude: 19.3613046,
      longitude: -99.2735343,
      phone: null,
      province: "México",
      address1: "Vasco de Quiroga 3800, Santa Fe",
      address2: "Contadero, Cuajimalpa de Morelos",
      city: "Ciudad de México",
      country: "Mexico",
      zip: "05348",
      countryCode: "MX",
      hours: '[[""],[""],[""],[""],[""],[""],[""]]',
    },
  },
  {
    id: "gid://shopify/Location/85779644630",
    name: "Liverpool - Coapa",
    address: {
      latitude: 19.3026292,
      longitude: -99.12330659999999,
      phone: null,
      province: null,
      address1: "Calz. del Hueso 519, Coapa",
      address2: "Residencial Miramontes, Tlalpan",
      city: "Ciudad de México",
      country: "Mexico",
      zip: "14300",
      countryCode: "MX",
      hours:
        '[["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85779677398",
    name: "Liverpool - Culiacán",
    address: {
      latitude: 24.813302,
      longitude: -107.4002565,
      phone: null,
      province: "Sinaloa",
      address1: "Boulevard José, Diego Valadés Ríos 1676",
      address2: "Desarrollo Urbano Tres Ríos",
      city: "Culiacán Rosales",
      country: "Mexico",
      zip: "80000",
      countryCode: "MX",
      hours: '[[""],[""],[""],[""],[""],[""],[""]]',
    },
  },
  {
    id: "gid://shopify/Location/85780234454",
    name: "Liverpool - Delta",
    address: {
      latitude: 19.3969198,
      longitude: -99.1561339,
      phone: null,
      province: "México",
      address1: "Av. Cuauhtémoc 462",
      address2: "Narvarte Poniente, Benito Juárez,",
      city: "Ciudad de México",
      country: "Mexico",
      zip: "03020",
      countryCode: "MX",
      hours: '[[""],[""],[""],[""],[""],[""],[""]]',
    },
  },
  {
    id: "gid://shopify/Location/85779710166",
    name: "Liverpool - Galerías Guadalajara",
    address: {
      latitude: 20.6773302,
      longitude: -103.4316705,
      phone: null,
      province: "Jalisco",
      address1: "Av Rafael Sanzio 150",
      address2: "Camichines Vallarta",
      city: "Zapopan",
      country: "Mexico",
      zip: "45020",
      countryCode: "MX",
      hours:
        '[["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85779742934",
    name: "Liverpool - Insurgentes",
    address: {
      latitude: 19.3732182,
      longitude: -99.1785709,
      phone: null,
      province: "México",
      address1: "Av. Insurgentes Sur 1310, Col del Valle Sur, Benito Juárez",
      address2: "",
      city: "Ciudad de México",
      country: "Mexico",
      zip: "03100",
      countryCode: "MX",
      hours:
        '[["10:00 a 22:00"],["11:00 a 22:00"],["11:00 a 22:00"],["11:00 a 22:00"],["11:00 a 22:00"],["11:00 a 22:00"],["11:00 a 22:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85779775702",
    name: "Liverpool - Lindavista",
    address: {
      latitude: 19.4859471,
      longitude: -99.1304287,
      phone: null,
      province: null,
      address1: "Calle Colector 13, 280 Parque",
      address2: "Lindavista, Gustavo A. Madero",
      city: "Ciudad de México",
      country: "Mexico",
      zip: "07760",
      countryCode: "MX",
      hours:
        '[["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85779808470",
    name: "Liverpool - Perisur",
    address: {
      latitude: 19.303739,
      longitude: -99.190184,
      phone: null,
      province: "México",
      address1:
        "Periferico Sur No. 4690, Jardines del Pedregal, , Ciudad de México, CDMX, México",
      address2: "",
      city: "Coyoacán",
      country: "Mexico",
      zip: "04500",
      countryCode: "MX",
      hours:
        '[["11:00 a 22:00"],["11:00 a 22:00"],["11:00 a 22:00"],["11:00 a 22:00"],["11:00 a 22:00"],["11:00 a 22:00"],["11:00 a 22:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85779841238",
    name: "Liverpool - Polanco",
    address: {
      latitude: 19.4341332,
      longitude: -99.18288,
      phone: null,
      province: "México",
      address1: "CDMX MX, Calz. Gral. Mariano Escobedo 425 , ,",
      address2: "Lomas de Chapultepec, Miguel Hidalgo",
      city: "Ciudad de México",
      country: "Mexico",
      zip: "11000",
      countryCode: "MX",
      hours: '[[""],[""],[""],[""],[""],[""],[""]]',
    },
  },
  {
    id: "gid://shopify/Location/85779874006",
    name: "Liverpool - Puebla",
    address: {
      latitude: 19.0715862,
      longitude: -98.22505749999999,
      phone: null,
      province: "Puebla",
      address1: "Boulevard Hermanos Serdán 270",
      address2: "Posadas",
      city: "Puebla",
      country: "Mexico",
      zip: "75750",
      countryCode: "MX",
      hours:
        '[["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85779906774",
    name: "Liverpool - Satélite",
    address: {
      latitude: 19.5104748,
      longitude: -99.2349988,
      phone: null,
      province: "México",
      address1:
        "Cto Centro Comercial 2251, ,  Naucalpan de Juárez, Méx., México",
      address2: "",
      city: "Cd. Satélite",
      country: "Mexico",
      zip: "53100",
      countryCode: "MX",
      hours: '[[""],[""],[""],[""],[""],[""],[""]]',
    },
  },
  {
    id: "gid://shopify/Location/85779939542",
    name: "Liverpool - Teófilo Borunda",
    address: {
      latitude: 31.691731,
      longitude: -106.429391,
      phone: null,
      province: "Chihuahua",
      address1: "Blvd. Teófilo Borunda 270",
      address2: "Colonia Partido Iglesias",
      city: "Cd Juárez",
      country: "Mexico",
      zip: "32618",
      countryCode: "MX",
      hours: '[[""],[""],[""],[""],[""],[""],[""]]',
    },
  },
  {
    id: "gid://shopify/Location/85780267222",
    name: "Liverpool - Zapopan",
    address: {
      latitude: 20.7115139,
      longitude: -103.4165927,
      phone: null,
      province: "México",
      address1: "Boulevard Puerta de Hierro",
      address2: "",
      city: "Zapopan",
      country: "Mexico",
      zip: "45116",
      countryCode: "MX",
      hours: '[[""],[""],[""],[""],[""],[""],[""]]',
    },
  },
  {
    id: "gid://shopify/Location/85780299990",
    name: "Pop Up Store - Barcelona",
    address: {
      latitude: 41.3928527,
      longitude: 2.1428891,
      phone: "+34 638 019 209",
      province: "Barcelona",
      address1: "Avenida Diagonal 606",
      address2: "",
      city: "Barcelona",
      country: "Spain",
      zip: "08021",
      countryCode: "ES",
      hours:
        '[["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["10:00 a 20:30"],["09:00 a 21:00"],["10:00 a 21:00"],["11:00 a 20:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85779972310",
    name: "Santiago de Chile - Parque Arauco",
    address: {
      latitude: -33.4021372,
      longitude: -70.5781786,
      phone: null,
      province: null,
      address1: "Av. Pdte. Kennedy 5413",
      address2: "",
      city: "Las Condes, Región Metropolitana",
      country: "Chile",
      zip: "7560994",
      countryCode: "CL",
      hours:
        '[["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"],["11:00 a 21:00"]]',
    },
  },
  {
    id: "gid://shopify/Location/85780005078",
    name: "Store 8",
    address: {
      latitude: 40.4244585,
      longitude: -3.6990948,
      phone: "+34 914 497 530",
      province: "Madrid",
      address1: "",
      address2: "",
      city: "Madrid",
      country: "Spain",
      zip: "28004",
      countryCode: "ES",
      hours:
        '[["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"],["10:00 a 21:00"]]',
    },
  },
];
